'use client';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';

/**
 * Placeholder shown in place of the frequency + amount selectors while the URL
 * query params are still resolving (`paramsReady === false`). Rendering the
 * real selectors before params load would show a pre-filter option set that
 * then changes (a visible flash), so we show a neutral skeleton instead.
 *
 * Kept intentionally simple: a frequency row and a row of amount buttons sized
 * to the `$button-height` (2.75rem) used by the real amount buttons.
 */
export const DonateFormSkeleton: React.FC = () => (
  <div
    className="DonateFormSkeleton flex flex-col gap-comfy-lg"
    aria-hidden="true"
  >
    {/* Frequency selector row */}
    <div className="flex w-full justify-center">
      <div className="w-1/2">
        <Skeleton height="1.25rem" borderRadius="0.5rem" />
      </div>
    </div>

    {/* Amount buttons row */}
    <div className="flex flex-col gap-comfy-sm">
      <div className="grid grid-cols-4 gap-comfy-sm">
        <Skeleton height={45} width="100%" borderRadius="0.5rem" />
        <Skeleton height={45} width="100%" borderRadius="0.5rem" />
        <Skeleton height={45} width="100%" borderRadius="0.5rem" />
        <Skeleton height={45} width="100%" borderRadius="0.5rem" />
      </div>

      <Skeleton height={44} width="100%" borderRadius="0.5rem" />
    </div>
  </div>
);
